// root '../../../';

// dependencies
import { Child } from 'pym.js';
import * as d3 from 'd3';
import Zion from './utils/Zion';

// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)

// styles
import './styles/graphic.scss';

/* develblock:start */
import meta from './data/meta.json';

import advisories from './data/advisories.json';

const pkg = require('../package.json');

d3.timeFormatDefaultLocale({
  periods: ['a.m.', 'p.m.'],
  days: [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ],
  shortDays: ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'],
  months: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  shortMonths: [
    'Jan.',
    'Feb.',
    'March',
    'April',
    'May',
    'June',
    'July',
    'Aug.',
    'Sept.',
    'Oct.',
    'Nov.',
    'Dec.',
  ],
});

const lastTwelveMonths = [
  [2024, 4],
  [2024, 5],
  [2024, 6],
  [2024, 7],
  [2024, 8],
  [2024, 9],
  [2024, 10],
  [2024, 11],
  [2025, 0],
  [2025, 1],
  [2025, 2],
  [2025, 3],
];


if (process.env.NODE_ENV === 'development') {
  console.clear();
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw, id: pkg.name });

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};

function draw() {
  const graphic = d3.select('#graphic');
  graphic.html('');
  lastTwelveMonths.forEach((m) => {
    const monthDate = new Date(m[0], m[1], 1);
    const monthContainer = graphic.append('div')
      .attr('class', 'month');
    monthContainer.append('h3')
      .attr('class', 'month-name')
      .html(`${d3.timeFormat('%b')(monthDate)} <span>${d3.timeFormat('%Y')(monthDate)}</span>`);
    const monthGrid = monthContainer.append('div');

    drawMonthSvg(m[0], m[1], monthGrid);
  });
  console.log(Object.keys(advisories).length);
  Object.keys(advisories).forEach((a) => {
    d3.select(`rect#d${a}`)
      .attr('fill', '#c00');
  });
}


function drawMonthSvg(year, month, containerSelection) {
  const cellSize = 10;
  const gutter = 3;
  const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  const monthEl = containerSelection.append('svg')
    .attr('width', 7 * (cellSize + gutter) - gutter)
    .attr('height', 6 * (cellSize + gutter) - gutter)
    .attr('viewBox', [0, 0, (7 * (cellSize + gutter) - gutter), (6 * (cellSize + gutter) - gutter)]);

  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);
  const numDays = lastDay.getDate();

  const dayData = d3.range(1, numDays + 1).map((d) => {
    const date = new Date(year, month, d);
    return {
      dateStr: d3.timeFormat('%Y-%m-%d')(date),
      dayNum: d,
      weekDay: date.getDay(),
      week: Math.floor((d + firstDay.getDay() - 1) / 7),
    };
  });

  const days = monthEl.selectAll('.day')
    .data(dayData)
    .enter()
    .append('rect')
    .attr('fill', '#D9D9D9')
    .attr('width', cellSize)
    .attr('height', cellSize)
    .attr('transform', d => `translate(${d.weekDay * cellSize + d.weekDay * gutter}, ${d.week * cellSize + d.week * gutter})`)
    .attr('id', d => `d${d.dateStr}`)
    .attr('class', 'day');
}
